import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { brands } from '../data/brands';
import { navLinks } from '../data/navigation';
import { company } from '../data/company';
import { productPages, productPagePath } from '../data/productPages';
import { locations, locationPath } from '../data/locations';
import { openCookieSettings } from '../utils/consent';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" data-track-location="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-about">
            <Link to="/" className="footer-brand" aria-label={`${company.name} — home`}>
              <img src="/logos/ojanna-logo-white.svg" alt="OJANNA" width="140" height="53" loading="lazy" />
              <span>Ceiling &amp; Drywall Distributors</span>
            </Link>
            <p>{company.description_short}</p>
            <img
              src="/sabisa.png"
              alt="SABISA Accredited"
              className="footer-sabisa"
              width="64"
              height="64"
              loading="lazy"
            />
          </div>

          <div>
            <h4 className="footer-title">Products</h4>
            <ul className="footer-links">
              {productPages.map((page) => (
                <li key={page.slug}>
                  <Link to={productPagePath(page)}>{page.name}</Link>
                </li>
              ))}
              <li>
                <Link to="/products">All products</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="footer-title">Delivery Areas</h4>
            <ul className="footer-links footer-links-cols">
              {locations.map((l) => (
                <li key={l.slug}>
                  <Link to={locationPath(l)}>{l.name.replace(/^the /, '')}</Link>
                </li>
              ))}
              <li>
                <Link to="/delivery-areas">All areas</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="footer-title">Visit &amp; contact</h4>
            <ul className="footer-contact">
              <li>
                <Icon name="pin" size={16} />
                <a href={company.mapsUrl} target="_blank" rel="noopener noreferrer">
                  {company.address.line1}, {company.address.line2}, {company.address.locality}, {company.address.region}
                </a>
              </li>
              <li>
                <Icon name="clock" size={16} />
                <span>
                  Mon–Thu {company.hours.weekdays}
                  <br />
                  Fri {company.hours.friday}
                </span>
              </li>
              {company.phones.map((phone) => (
                <li key={phone.href}>
                  <Icon name="phone" size={16} />
                  <a href={phone.href}>
                    {phone.number} <small>{phone.label}</small>
                  </a>
                </li>
              ))}
              <li>
                <Icon name="mail" size={16} />
                <a href={`mailto:${company.email}`}>
                  {company.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-brands">
          <p className="footer-brands-label">Brands we distribute</p>
          <div className="footer-brands-logos">
            {brands.map((brand) => (
              <Link to={`/partners#${brand.id}`} key={brand.id} title={brand.name}>
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className={brand.invertOnDark ? 'invert-white' : ''}
                  loading="lazy"
                />
              </Link>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © {currentYear} {company.name}. All rights reserved.
          </p>
          <nav className="footer-legal" aria-label="Footer">
            {navLinks
              .filter((l) => l.path !== '/')
              .map((link) => (
                <Link key={link.path} to={link.path}>
                  {link.label}
                </Link>
              ))}
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
            <Link to="/terms-of-use">Terms of Use</Link>
            <button type="button" className="footer-cookie-btn" onClick={openCookieSettings}>
              Cookie settings
            </button>
          </nav>
          <p className="footer-built-by">
            Designed &amp; Hosted by <span className="footer-credit-brand">Seder Consulting</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
